import BaseCheckbox from 'components/atoms/baseCheckbox';
import React from 'react';

import s from './styles.module.scss';
import FormItemExtra from './formItemExtra';

import type { FC } from 'react';
import type { IFormSubItemProps } from './types';
import type { FormikValues } from 'formik';

const CheckboxItem: FC<IFormSubItemProps & { generalName: string }> = ({
  formik,
  option,
  generalName,
}) => {
  const onHandleCheckbox = <T extends FormikValues>(
    key: keyof T & string,
    name: string,
    val: boolean,
  ) => {
    const oldValues = Array.isArray(formik.values[key])
      ? formik.values[key]
      : [];

    if (val) {
      formik.setFieldValue(key, [...oldValues, name]);
    } else {
      const newValues = oldValues?.filter((value) => value !== name);
      formik.setFieldValue(key, newValues);

      if (option?.optionChildren?.length) {
        option.optionChildren.forEach((child) => {
          if (child.type === 'checkbox') {
            formik.setFieldValue(child.name, []);
          }
        });
      }
    }
  };

  const showChildren = formik.values[generalName]?.includes(option.label);

  return (
    <React.Fragment key={option.key}>
      <BaseCheckbox
        label={option.label}
        onChange={(val) => onHandleCheckbox(generalName, option.label, val)}
        checked={formik.values[generalName].includes(option.label)}
        className={s['checkbox-item']}
      />

      {showChildren &&
        option?.optionChildren?.map((child) => (
          <FormItemExtra formik={formik} {...child} isChild />
        ))}
    </React.Fragment>
  );
};

export default CheckboxItem;
